module.exports = __webpack_public_path__ + "static/media/office2.5df804d5.jpg";